import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_ADMISSION_LEVEL_VACANCIES_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AdmissionLevelRequest {
  admissionLevel: string;
  dateOfBirthFrom: string;
  dateOfBirthTo: string;
  totalExamVacancy: number;
  year: number;
  examGroupLevel: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAdmissionLevelVacancies = ({ onSuccess, onError }: Input = {}) => {
  const postAdmissionLevelVacancies = async (reqBody: AdmissionLevelRequest) => {
    const res = await axiosClient.post(POST_ADMISSION_LEVEL_VACANCIES_URL, reqBody);
    return res.data;
  };

  return useCustomMutation(postAdmissionLevelVacancies, {
    onSuccess,
    onError,
  });
};
